<template>
  <div>
    <navBar />
    <div class="main main-container">
      <div class="banner">
        <img src="@/assets/images/caseCar/banner.png" />
        <div class="banner-title">CRM&SCRM</div>
      </div>
      
      <div class="container">
        <img src="@/assets/images/marketingPlatform/bg.jpg" class="big-bg"/>
        <div class="wrap-nav">
          <div class="wrap-nav-describe">
            丰富的客户运营管理，包括会员等级、权益与积分管理，忠诚度管理，实现客户精细化分层与运营，减少用户流失，提高品牌忠诚度与交易贡献。社区UGC还可以更多客户互动，社交裂变与传播，积累客户互动价值。
          </div>
        </div>
        <div class="content">
          <div class="describe">
            <img src="@/assets/images/crm/crm.png" />
            <div class="vip-box">
              <p>会员等级与积分管理</p>
              <p>会员等级管理，自动化升降级。支持交易积分或互动多类型积分管理，支持会员等级进行积分系数配置。</p>
            </div>
          </div>
          <div class="describe">
            <div class="error-box">
              <p>异常规则管理</p>
              <p>支持自定义异常规则，杜绝会员权益作弊导致积分溢出而产生的财务风险。</p>
            </div>
            <img src="@/assets/images/crm/crm2.png" />
          </div>
          <div class="title">UGC社区管理</div>
          <div class="describe" style="margin-top: 10px ">
            <img src="@/assets/images/crm/crm3.png" />
            <div class="ugc-box">
              <p></p>
              <p>
                UGC信息流，帮助品牌创造客户发声与运营阵地，挖掘品牌KOL和KOC，支持收藏，点赞，评论，关注等社交功能。
              </p>
            </div>
          </div>
          <div class="describe">
            <div class="last-box" style="margin-top:100px">
                <p></p>
                <p>
                  积分与任务体系的结合，帮助品牌更好的增加会员交易外的活跃，提升会员对于品牌的日常关注度和喜爱。<br /><br />
                  支持微信生态裂变传播，扩大影响力，有助于利用社交模式进行用户快速增长，同时形成内容的高效传播。<br /><br />
                  内容与电商和导购打通，可直接关联交易与导购服务，拉进沟通提高业务转化率。
                </p>
            </div>
            <img src="@/assets/images/crm/crm4.png" style="margin-top:-70px"/>
          </div>
        </div>
      </div>
    </div>
    <footerBar />
  </div>
</template>
<script>
import navBar from "@/components/nav-bar";
import footerBar from "@/components/footer-bar";
export default {
  data() {
    return {};
  },
  components: {
    navBar,
    footerBar
  },
};
</script>
<style  lang="scss" scoped>
.main {
  max-width: 1920px;
  min-width: $min-screen-width;
  margin: 0 auto;
  font-family: Source Han Sans CN;

  .banner {
    position: relative;
    height: 430px;
    overflow: hidden;
    .banner-title {
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      // line-height: 68px;
      color: #FFFFFF;
      position: absolute;
      top: 208px;
      left: 575px;
    }
  }
  .wrap-nav {
    margin: 0 auto;
    margin-top: 58px;
    // width: 1200px;
    position: relative;
    z-index: 10;

    .wrap-nav-describe {
      margin: 0 auto;
      margin-top: 110px;
      text-align: center;
      width: 990px;
      font-size: $font-size-20;
      line-height: 32px;
      color: #707070;
    }
  }

  .title {
    margin-top: 100px;
    text-align: center;
    position: relative;
    font-size: 32px;
    // font-family: Source Han Sans CN;
    color: #333333;
  }

  .title:after {
    content: " ";
    transform: translateX(-50%);
    width: 60px;
    height: 2px;
    background: #1f71ff;
    position: absolute;
    top: 52px;
    left: 50%;
  }
  p:nth-child(1) {
    font-size: $font-size-20;
    font-weight: bold;
    line-height: 50px;
    color: #464646;
  }
  p:nth-child(2) {
    margin-top: 30px;
    width: 360px;
    font-size: $font-size-18;
    font-family: SourceHanSansCN-Normal;
    line-height: 28px;
    color: #707070;
    opacity: 1;
  }
}

.container {
  height: 3525px;
  position: relative;
  overflow: hidden;
  .big-bg {
    position: absolute;
  }
  .content {
    width: 1200px;
    height: 3525px;
    position: relative;
    margin: 0 auto;
    .describe {
      display: flex;
      margin-top: 230px;
      .vip-box {
        padding-left: 75px;
        padding-top: 48px
      }
      .error-box {
        padding-left: 59px;
        padding-right: 67px;
        margin-top: 150px;
      }
      .ugc-box {
        padding-top: 217px;
        padding-left: 289px; 
      }
      .last-box {
        padding-left: 59px; 
        padding-right: 182px; 
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/crm/index.vue